export class Solicitud {
  // Identificador único
  t2_id: string | null;
  
  // Número de registro
  t2_numero_registro: string;
  
  // I. Funcionario responsable
  t2_funcionario_responsable: string;
  
  // II. Datos del solicitante
  t2_apellidos_nombres: string;
  t2_tipo_documento: string; // DNI, L.M., C.E., OTRO
  t2_numero_documento: string;
  
  // Domicilio
  t2_direccion: string; // AV / CALLE / JR. / PSJ.
  t2_numero_direccion: string; // Nº / DPTO / INT.
  t2_distrito: string;
  t2_urbanizacion: string;
  t2_provincia: string;
  t2_departamento: string;
  
  // Contacto
  t2_correo_electronico: string;
  t2_telefono: string;
  
  // III. Información solicitada
  t2_informacion_solicitada: string;
  
  // IV. Dependencia
  t2_dependencia: string;
  
  // V. Forma de entrega
  t2_entrega_copia_simple: boolean;
  t2_entrega_diskette: boolean;
  t2_entrega_cd: boolean;
  t2_entrega_correo_electronico: boolean;
  t2_entrega_otro: boolean;
  t2_entrega_otro_especificar: string;
  
  // Observaciones
  t2_observaciones: string;
  

  // Metadatos
  t2_fecha_creacion: Date;
  t2_fecha_actualizacion: Date | null;
  t2_usuario_creacion: string;
  t2_usuario_actualizacion: string | null;

  constructor() {
    this.t2_id = null;
    this.t2_numero_registro = '';
    this.t2_funcionario_responsable = '';
    this.t2_apellidos_nombres = '';
    this.t2_tipo_documento = 'DNI';
    this.t2_numero_documento = '';
    this.t2_direccion = '';
    this.t2_numero_direccion = '';
    this.t2_distrito = '';
    this.t2_urbanizacion = '';
    this.t2_provincia = '';
    this.t2_departamento = '';
    this.t2_correo_electronico = '';
    this.t2_telefono = '';
    this.t2_informacion_solicitada = '';
    this.t2_dependencia = '';
    this.t2_entrega_copia_simple = false;
    this.t2_entrega_diskette = false;
    this.t2_entrega_cd = false;
    this.t2_entrega_correo_electronico = false;
    this.t2_entrega_otro = false;
    this.t2_entrega_otro_especificar = '';
    this.t2_observaciones = '';
    this.t2_fecha_creacion = new Date();
    this.t2_fecha_actualizacion = null;
    this.t2_usuario_creacion = '';
    this.t2_usuario_actualizacion = null;
  }
}
